import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore'; //Cloud Firestore
import { FirebaseTourModel } from '../data-model/tour.model';
import { FirebaseUserModel } from '../data-model/user.model';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

  constructor(
    private db: AngularFirestore,
    private storage: StorageService
  ) { }

  //Obtener campos del usuario
  getUser(uid: string) {
    return this.db.firestore.collection('users').doc(uid);
  }
  //Crear o actualizar el usuario
  createUpdateUser(uid, user: FirebaseUserModel) {
    return this.db.collection('users').doc(uid).set(user.toObject(), { merge: true });
  }

  //Obtener continentes
  getContinents() {
    return this.db.firestore.collection('continents');
  }
  //Obtener países del continente seleccionado
  getCountries(continent) {
    return this.db.firestore.collection('countries').where('continent', '==', continent);
  }
  //Obtener ciudades del país seleccionado
  getCities(country) {
    return this.db.firestore.collection('cities').where('country', '==', country);
  }
  //Obtener tours publicados de la ciudad seleccionada
  getTours(city) {
    return this.db.firestore.collection('tours').where('city', '==', city).where('isPublished', '==', true);
  }
  //Obtener cierto número de tours publicados
  getToursLimit(limit: number) {
    return this.db.firestore.collection('tours').where('isPublished', '==', true).limit(limit);
  }
  //Obtener campos de un tour
  getTour(id: string) {
    return this.db.collection('tours').doc(id);
  }
  //Obtener tours de un usuario
  getUserTours(uid) {
    return this.db.collection('tours', ref => ref.where('uid', '==', uid));
  }
  //Crear tour
  createTour(tour: FirebaseTourModel) {
    //Add es para crear el doc (id) y toda la info del tour. Set es para crear la info si ya tuviera el id
    return this.db.collection('tours').add(tour.prepareTourObject());
  }
  //Actualizar tour
  updateTour(tour: FirebaseTourModel) {
    return this.db.collection('tours').doc(tour.id).update(tour.prepareTourObject());
  }
  //Borrar tour
  async deleteTour(id: string) {
    const tourData = await this.db.collection('tours').doc(id).get().toPromise(); //Consigo el tour a partir de su id
    if (tourData) {
      var tour = FirebaseTourModel.objectToModel(tourData.data()); //Si lo consigue bien, lo convierte a Modelo de datos

      if(tour.fileLocation)
        this.storage.delete(tour.fileLocation).toPromise();
      //Inicializo una lista de promesas de los elementos a borrar para asegurarme de que todos se hayan borrado bien
      var elementosBorrar = []; 
      tour.puntosTour.forEach(punto => {
        punto.elementosMedia.forEach(elementoMedia => {
          if (elementoMedia.intoStorage == true) { //Si el elem.media está en el storage
            //Llamo al borrar del storage y guardo la promesa en la lista
            elementosBorrar.push(this.storage.delete(elementoMedia.fileLocation).toPromise()); 
          }
        })
      });
      //Espero a que todas las promesas (borrar del storage) terminen y compruebo su estado
      const results = await Promise.allSettled(elementosBorrar) 

      var success = true; //Inicializo una variable para saber si ha ido bien
      results.forEach(result => {
        if (result.status == 'rejected') { //Si una ha ido mal
          if (result.reason.code != "storage/object-not-found") { //Y la razón no es que ya no exista en el storage
            success = false; //Ha ido mal
            throw new Error(result.reason); //Le dice a la promesa la razón del fallo
          }
        }
      });

      if (success) { //Ha ido bien el borrar del storage
        await this.db.collection('tours').doc(id).delete(); //Borro de la BBDD
        return true;
      }
    }
  }
  //Publicar tour
  publishTour(id: string, publish: boolean) {
    return this.db.collection('tours').doc(id).update(
      { isPublished: publish }
    )
  }
}